import { render, staticRenderFns } from "./time-diff.vue?vue&type=template&id=b4c7564c"
import script from "./time-diff.vue?vue&type=script&lang=js"
export * from "./time-diff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports